import revive_payload_client_4sVQNw7RlN from "/app/frontend/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import router_jmwsqit4Rs from "/app/frontend/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import plugin_vue3_A0OWXRrUgq from "/app/frontend/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/app/frontend/.nuxt/components.plugin.mjs";
import unhead_KgADcZ0jPj from "/app/frontend/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import prefetch_client_5tzzN0oIVL from "/app/frontend/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import chunk_reload_client_UciE0i6zes from "/app/frontend/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import draggable_hMJ3P6uXQ1 from "/app/frontend/plugins/draggable.ts";
import helpscout_aU0gSl4kdB from "/app/frontend/plugins/helpscout.ts";
import sentry_client_shVUlIjFLk from "/app/frontend/plugins/sentry.client.ts";
import version_manager_AcvmOsZYgE from "/app/frontend/plugins/version-manager.ts";
import vue_mathlive_qS7M46OoWE from "/app/frontend/plugins/vue-mathlive.ts";
import vue_snip_nFNJ2EgT6o from "/app/frontend/plugins/vue-snip.ts";
import vuetify_client_69rYAaPZnF from "/app/frontend/plugins/vuetify.client.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  router_jmwsqit4Rs,
  plugin_vue3_A0OWXRrUgq,
  components_plugin_KR1HBZs4kY,
  unhead_KgADcZ0jPj,
  prefetch_client_5tzzN0oIVL,
  chunk_reload_client_UciE0i6zes,
  draggable_hMJ3P6uXQ1,
  helpscout_aU0gSl4kdB,
  sentry_client_shVUlIjFLk,
  version_manager_AcvmOsZYgE,
  vue_mathlive_qS7M46OoWE,
  vue_snip_nFNJ2EgT6o,
  vuetify_client_69rYAaPZnF
]